export default "__VITE_ASSET__DGrruIeT__"